﻿export function setPropByElement(element, property, value) {
    element[property] = value;
}
